module.exports = __webpack_public_path__ + "static/media/iitm-logo-new.fdf61623.png";